import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import { DataView, EmptyState } from "/imports/ui/components/shared";
import { PackHorizonBanner } from "/imports/ui/components/booking";
import ClassMobileFilterBar from "./components/ClassMobileFilterBar";
import ClassDaySections from "./components/ClassDaySections";
import ClassFilterSheet from "./components/ClassFilterSheet";

// Mobile layout — sticky filter chips + week day-strip (scroll-spy) that scrolls
// through the whole week's classes grouped by day.
function ClassesMobileLayout({ cls, scrollSpy }) {
  const { navigate, slug, loading, error, timetable, weekHasClasses, emptyStateProps } = cls;

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 2 }}>
        <IconButton size="small" onClick={cls.goBack} aria-label="Go back" sx={{ ml: -0.5 }}>
          <ArrowBackIcon />
        </IconButton>
        <Typography sx={{ fontSize: "1.4rem", fontWeight: 800, letterSpacing: "-0.02em" }}>Group Classes</Typography>
      </Box>

      <ClassMobileFilterBar cls={cls} scrollSpy={scrollSpy} />

      <Box mt={2}>
        {/* Sits with the days it is talking about: on a phone, under the title
            it meant the header, two lines of dates and six filter controls all
            landed before a single class did. */}
        <PackHorizonBanner
          horizon={cls.ownedPackHorizon}
          start={cls.ownedPackStart}
          count={cls.ownedPackCount}
          capped={cls.ownedPackCapped}
          onJump={cls.goToPackStart}
          sx={{ mb: 1.5 }}
        />

        <DataView loading={loading} error={error} data={timetable} loadingMessage="Loading classes...">
          {weekHasClasses ? <ClassDaySections cls={cls} scrollSpy={scrollSpy} /> : <EmptyState {...emptyStateProps} />}
        </DataView>
      </Box>

      <ClassFilterSheet cls={cls} />
    </Box>
  );
}

export default ClassesMobileLayout;
